import { AUTH_CONFIG } from "./config";
import TokenPersistor from "./persistor";

const { auth_token_response_formatter } = AUTH_CONFIG;

const Authenticator = (function () {
  function persistTokens(data) {
    TokenPersistor.write("access_token", data.access_token);
    TokenPersistor.write("refresh_token", data.refresh_token);
    // TokenPersistor.write('user', data.user);
  }

  function isAuthenticated() {
    return Boolean(TokenPersistor.read("access_token"));
  }

  function getTokens() {
    return {
      access_token: TokenPersistor.read("access_token"),
      refresh_token: TokenPersistor.read("refresh_token"),
    };
  }
  function getUser() {
    const user = TokenPersistor.read("user");
    return {
      email: user?.email,
      role: user?.role?.toLowerCase(),
      name: user?.name,
    };
  }
  function login(data) {
    persistTokens(auth_token_response_formatter(data));
  }

  function logout(forced = false) {
    TokenPersistor.purge();
  }

  return {
    persistTokens,
    isAuthenticated,
    getTokens,
    getUser,
    login,
    logout,
  };
})();

export default Authenticator;
